<div class="select" [formGroup]="formGroup">
  <select [formControlName]="'language'">
    @for (lang of supportedLanguages; track lang.languageId) {
      <option [value]="lang.languageId">{{ lang.englishLanguageName }} ({{ lang.nativeLanguageName }})</option>
    }
  </select>
</div>
